import { computed } from 'vue';
import { usePage } from '@inertiajs/vue3';
import { format, parseISO, parse, isPast, endOfMonth } from 'date-fns';
import { de, enUS } from 'date-fns/locale';
import { formatInTimeZone } from 'date-fns-tz';

const locales = { enUS, de };
const defaultTimeZone = 'Europe/Berlin';

const page = usePage();
const dateLocale = computed(() => page?.props?.dateLocale || 'de');
const defaultFormatOptions = computed(() => ({ locale: locales[dateLocale.value] }));

export function useGetLocalizedDateTime(date, dateTimeFormat = 'Pp') {
    return formatInTimeZone(parseISO(date), defaultTimeZone, dateTimeFormat, defaultFormatOptions.value);
}

export function useGetLocalizedTime(time, timeFormat = 'p') {
    return format(parse(time, 'HH:mm:ss', new Date()), timeFormat, defaultFormatOptions.value);
}

export function useGetLocalizedDate(date, timeFormat = 'P') {
    return format(parse(date, 'dd.MM.yyyy', new Date()), timeFormat, defaultFormatOptions.value);
}

export function useIsPastDateTime(date, ignoreDay = false, ignoreTime = false) {
    let parsedDateTime = parseISO(date);

    if (ignoreTime) {
        parsedDateTime.setHours(23, 59, 59);
    }

    if (ignoreDay) {
        parsedDateTime = endOfMonth(parsedDateTime);
    }

    return isPast(parsedDateTime);
}
